import { render, staticRenderFns } from "./TaskPriorityChips.vue?vue&type=template&id=4299781d&scoped=true"
import script from "./TaskPriorityChips.vue?vue&type=script&lang=ts"
export * from "./TaskPriorityChips.vue?vue&type=script&lang=ts"
import style0 from "./TaskPriorityChips.vue?vue&type=style&index=0&id=4299781d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4299781d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4299781d')) {
      api.createRecord('4299781d', component.options)
    } else {
      api.reload('4299781d', component.options)
    }
    module.hot.accept("./TaskPriorityChips.vue?vue&type=template&id=4299781d&scoped=true", function () {
      api.rerender('4299781d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tasks/TaskPriorityChips.vue"
export default component.exports